import axios from "axios";
import { BASE_URL } from "./api";


export async function getExpenseCategories(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/expense-categories/`,
        headers: {
            'Authorization': `Token ${token}`,
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error;
    });
}
